/* eslint-disable */
import createIcon from '../createIcon';

const IconSwitchCross = createIcon({
  name: 'icon-switch-cross',
  content: '<path d="M760.96 308.352L557.12 511.936l203.712 203.712-45.248 45.248-203.712-203.712-203.584 203.712-45.248-45.248 203.648-203.712L263.04 308.352l45.248-45.248L512 466.56l203.648-203.52 45.248 45.248z"/>',
  width: 1024,
  height: 1024
});
export default IconSwitchCross;
